import { AlertCircle } from "lucide-react";

import { LoginWithElationButton } from "../LoginWithElationButton";

export function ExistingElationAccountPanel() {
  return (
    <div className="flex w-full max-w-[416px] flex-col items-center rounded-[18px] border border-destructive/30 bg-background px-7 py-8 text-center shadow-[0_18px_50px_rgba(20,23,26,0.10)]">
      <div className="flex size-[68px] items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertCircle className="size-7" />
      </div>
      <h2 className="mt-5 text-xl font-semibold tracking-[-0.4px] text-foreground">
        This email is already registered with Elation
      </h2>
      <p className="mt-2 max-w-[320px] text-sm leading-[1.55] text-muted-foreground">
        An Elation account with this email already exists. Sign in with your
        Elation credentials instead of creating a new account.
      </p>
      <LoginWithElationButton className="mt-6" enabled size="lg" />
    </div>
  );
}
